/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

import MODAL_VIEW_TYPES from "../../../constants/modalViewTypes";
import { withNamespace } from "../../constants/namespace";

const initialState = {
  isExpertMatchDrawerOpen: false,
  modalViewType: MODAL_VIEW_TYPES.agentContact
};

const uiSlice = createSlice({
  name: withNamespace("ui"),
  initialState,
  reducers: {
    openExpertMatchDrawer(state) {
      state.isExpertMatchDrawerOpen = true;
    },
    closeExpertMatchDrawer(state) {
      state.isExpertMatchDrawerOpen = false;
    },
    setModalViewType(state, { payload }) {
      state.modalViewType = payload;
    }
  }
});

export const {
  closeExpertMatchDrawer,
  openExpertMatchDrawer,
  setModalViewType
} = uiSlice.actions;

export default uiSlice.reducer;
